GatorSurvey.app.directive("gsCheckboxQuestion", ['surveyResponseService', GsCheckboxQuestion]);
function GsCheckboxQuestion(surveyResponseService) {
    return {
        restrict: 'AE',
        scope: {
            gsModel: "=ngModel",
            mode: "=?"
        },
        templateUrl: 'Assets/Scripts/App/Directives/Questions/Templates/CheckboxQuestionLive.html',
        controller: ['$scope', function ($scope) {
            $scope.isOtherChecked = false;
            $scope.useIfOther = false;
            $scope.checkDisabled = function (item) {
                if (!$scope.gsModel.limitChecks)
                    return false;

                if (item === "other")
                    if ($scope.isOtherChecked === true) {
                        return false;
                    }

                if (item.checked)
                    return false;
                var countCheck = 0;
                for (var i = 0; i < $scope.gsModel.offeredAnswers.length; i++) {
                    var check = $scope.gsModel.offeredAnswers[i];
                    if (check.checked) {
                        countCheck++;
                    }
                }
                if ($scope.isOtherChecked)
                    countCheck++;
                return countCheck++ >= $scope.gsModel.unit;
            };
            
            $scope.checkboxChange = function (offeredAnswer) {

                var id = getUrlParameter("t") !== "1" ? offeredAnswer.id : offeredAnswer.tempId;

                surveyResponseService.updateResponseQuestion($scope.gsModel, offeredAnswer.checked, [id, false]);
            };

            $scope.checkboxOtherText = function (text) {
                    surveyResponseService.updateResponseQuestion($scope.gsModel, text, [null, 'text']);
            };

            $scope.checkboxChangeOther = function (elem) {
                surveyResponseService.updateResponseQuestion($scope.gsModel, null, [elem.target.checked, 'isOther']);
                $scope.isOtherChecked = elem.target.checked;
            };

           
            surveyResponseService.AddNewQuestion($scope.gsModel,
                function(reponce) {
                    for (var i = 0; i < $scope.gsModel.offeredAnswers.length; i++) {
                        for (var a = 0; a < reponce.answers.length; a++) {
                            if (reponce.answers[a] === $scope.gsModel.offeredAnswers[i].id) {
                                $scope.gsModel.offeredAnswers[i].checked = true;
                                continue;
                            }
                            if (reponce.answers[a].indexOf("IsOther") > -1 && $scope.gsModel.useIfOther) {
                                $scope.isOtherChecked = true;
                                var otherText = reponce.answers[a].substring("IsOther:".length - 1,
                                    reponce.answers[a].length - ("IsOther:".length - 1));

                                $scope.gsModel.otherText = otherText == null ? '' : otherText;
                                continue;
                            }
                        }
                    }
                });
            

        }]
    };
}